// LIBRARIES
import styled from "styled-components";

// MISC
import {
  COLORS,
  BORDER_RADIUS,
  SIZE,
  MARGIN,
  DEVICE_TYPE, FONT_FAMILY, FONT_WEIGHT,
} from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const HeaderContainer = styled.header<{ $hasSectionNavigation?: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  top: 0;
  background-color: ${COLORS.VividAuburn};
  z-index: 1000;
  align-items: center;
  position: sticky;
  box-shadow: ${({ $hasSectionNavigation }) => $hasSectionNavigation ? "none" : `0px 4px 10px ${COLORS.boxShadow}`};
  padding: 0 ${MARGIN.fix32};
  height: 80px;
  border-bottom-left-radius: ${({ $hasSectionNavigation }) => $hasSectionNavigation ? "0" : BORDER_RADIUS.radius24};
  border-bottom-right-radius: ${({ $hasSectionNavigation }) => $hasSectionNavigation ? "0" : BORDER_RADIUS.radius24};
`;

export const Logo = styled.img<{ biggerCursor?: boolean }>`
  height: 42px;
  width: 42px;
  margin-right: 8px;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;


export const LogoText = styled.p`
  font-family: ${FONT_FAMILY.poppins};
  color: ${COLORS.Yellow};
  white-space: pre-wrap;
  font-weight: ${FONT_WEIGHT.semiBold};
  line-height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: ${SIZE.max16};
  justify-self: flex-start;
`;

export const LogoTextContainer = styled.button<{ biggerCursor?: boolean }>`
  display: flex;
  align-items: center;
  border: 0;
  background-color: ${COLORS.VividAuburn};
  padding-right: ${SIZE.fix16};
  height: 50px;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    height: 42px;
  }
`;

export const LogoContainer = styled.div<{ biggerCursor?: boolean }>`
  display: flex;
  align-items: center;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;
